import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_428: DocMigration = {
  maxSchemaVersion: "0.0.428",
  description: "Add entity refs for optionLocks with a ref'd optionSet",
  apply(json: any) {
    for (const optionLockId in json.optionLocks) {
      const optionSetId = json.optionLocks[optionLockId].optionSetId;
      const optionSetEntityRef = json.entityRefs[optionSetId];
      const optionLockEntityRef = json.entityRefs[optionLockId];
      // Skip if the optionLock already has an entityRef
      if (!optionLockEntityRef && optionSetEntityRef) {
        json.entityRefs[optionLockId] = {
          id: optionLockId,
          entityId: optionLockId,
          docRefId: optionSetEntityRef.docRefId,
        };
      }
    }

    return json;
  },
};

export default migration_0_0_428;
